import { connect, MapStateToProps } from 'react-redux'
import { Props } from './TechnicalDataButton'
import { State } from '../../redux/reducers/rootReducer'
import { openInfoModal } from '../../redux/actions/app/infoModal.actions'
import configurationStringSelector from '../../redux/selectors/configuration/configurationStringSelector'
import cartNameSelector from '../../redux/selectors/cart/cartNameSelector'

type StateProps = Pick<Props, 'configurationString' | 'modelName'>

const mapStateToProps: MapStateToProps<StateProps, {}, State> = (state): StateProps => ({
    configurationString: configurationStringSelector(state),
    modelName: cartNameSelector(state),
})

type DispatchProps = Pick<Props, 'openInfoModal'>

const mapDispatchToProps: DispatchProps = {
    openInfoModal,
}

export default connect(mapStateToProps, mapDispatchToProps) 